var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#455079;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-306 -1142.995)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.23,1158.043a12.094,12.094,0,0,0-1.411-.566,6.375,6.375,0,1,0-7.633,0,12.193,12.193,0,0,0-8.125,9.088,2.848,2.848,0,0,0,2.784,3.435h11.546a.938.938,0,0,0,0-1.875H311.845a.954.954,0,0,1-.75-.357.98.98,0,0,1-.2-.821,10.359,10.359,0,0,1,9.855-8.2h.5a10.21,10.21,0,0,1,4.174.991.938.938,0,0,0,.8-1.693Zm-5-1.173h-.456a4.5,4.5,0,1,1,.456,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(324 1163)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUser);
export default __webpack_public_path__ + "static/media/remove-user.c8230e1db499e9a907209552dc788ac4.svg";
export { ForwardRef as ReactComponent };